<script setup lang="ts">
import { StoryTile } from '@caks/uikit/story'
import { MiscTrack } from '@caks/uikit/misc'
import { Story } from '@caks/shared/types/types.api'
import { useAccountStore } from '@caks/shared/store/store.account'

interface Props {
  stories: Array<Story>
  desktop?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  desktop: false,
})

const store = useAccountStore()

defineEmits<{
  (e: 'openStory', index: number): void
}>()

const params = {
  mobile: {
    gap: '8px',
    height: '94px',
    'item-width': '94px',
  },
  desktop: {
    gap: '20px',
    height: '152px',
  },
}
</script>

<template>
  <misc-track v-bind="desktop ? params.desktop : params.mobile" :desktop="desktop">
    <story-tile
      v-if="stories.length"
      v-for="(story, index) in stories"
      @click="$emit('openStory', index)"
      :image-path="story.preview_image"
      :watched="store.watchedStoriesIds.includes(story.id)"
    />
    <skeletor style="border-radius: 10px" v-else v-for="n of 4" />
  </misc-track>
</template>

<style scoped>
/* .story{
  height: v-bind(desktop? '152px' : params.mobile)
} */
</style>
